module.exports = __webpack_public_path__ + "static/media/taraHockeyOne.1fe1cf90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taraHockeyOne.svg
// module id = 614
// module chunks = 0